export default "__VITE_ASSET__CKxxf7I6__"